"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var priceFormatter_1 = require("../../service/priceFormatter");
var useWidgetContext_1 = require("../../../../common/react/useWidgetContext");
exports.gqlPriceFormatter = function () {
    var _a = usePlatformConfig_1.default().platformConfig.priceDisplay.primaryOptions, currency = _a.currency, decimalScale = _a.decimalScale, currencyFormatConfig = _a.currencyFormatConfig;
    var _b = useWidgetContext_1.default().configuration.dimensions, language = _b.language, country = _b.country;
    return priceFormatter_1.default.getFormatter({
        language: language,
        country: country,
        currency: currency,
        decimalScale: decimalScale,
        currencyFormatConfig: currencyFormatConfig,
    });
};
